// Tiny axios wrapper for the Data Recovery TV Board.
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE = `${BACKEND_URL}/api/data-recovery`;

export async function fetchBoard() {
  const { data } = await axios.get(`${BASE}/board`, { timeout: 25000 });
  return data;
}

export async function fetchHealth() {
  const { data } = await axios.get(`${BASE}/healthcheck`, { timeout: 15000 });
  return data;
}
